<template>
  <div class="lx-content">
    <div style="position: absolute;width: 100%;height: 100%;z-index: 1;overflow: hidden;">
      <iframe id="" :src="vedioSrc" width="100%" height="100%" allowfullscreen>
      </iframe>
    </div>
    <div class="lx-content-body">
      <div class="lx-content-body-top flex">
        <div class="lx-content-body-top_bg flex">
          <div class="body-top-left flex-al-center">
            <div class="icon-xuan"></div>
            <span class="content-span">碳排放量：{{ codata }}㎏</span>
          </div>
          <div class="body-top-center flex-center">
            <div class="main-tit"><span>泰豪第二会议室</span></div>
          </div>
          <div class="body-top-right flex-center">
            <div style="margin-left: 8rem;"><span class="content-span">电量:{{ dia }}Kwh</span></div>
            <div class="icon-xuan"></div>
          </div>
        </div>
      </div>
      <div class="lx-content-body-content flex">
        <div class="main-left"></div>
        <div class="main-center">
          <div class="air-data-box flex-center" style="flex-wrap: wrap;">
            <div style="margin-right: 3%;color: #fff;">室内环境数据</div>
            <div style="margin-right: 3%;color: #fff;">CO2：{{ airData.CO2 }}PPM</div>
            <div style="margin-right: 3%;color: #fff;">温度：{{ airData.Temp }}℃</div>
            <div style="margin-right: 3%;color: #fff;">湿度：{{ airData.Humd }}%</div>
            <div style="margin-right: 3%;color: #fff;">VOC：{{ airData.VOC }}PPM</div>
          </div>
          <div class="air-data-box flex-center" style="flex-wrap: wrap;right: 65%;">
            <div style="margin-right: 3%;color: #fff;">室外环境数据</div>
            <div style="margin-right: 3%;color: #fff;">温度：{{ airof.temp }}℃</div>
            <div style="margin-right: 3%;color: #fff;">风向：{{ airof.windDir }}</div>
            <div style="margin-right: 3%;color: #fff;">湿度：{{ airof.humidity }}%</div>
            <div style="margin-right: 3%;color: #fff;">状态：{{ airof.text }}</div>
          </div>
          <div @click="verticalAirConditioningOn" class="btn flex-center"
            style="position: absolute;left: 78%;top: 17%;;border: 1px solid #fff;box-shadow: 0 0 10px #fff;background-color: #5f6975cc;">
            <span class="tit" style="color: #fff;">空调</span>
          </div>
          <div @click="freshAirFanOn" class="btn flex-center"
            style="position: absolute;left: 91%;top: 17%;;border: 1px solid #fff;box-shadow: 0 0 10px #fff;background-color: #5f6975cc;">
            <span class="tit" style="color: #fff;">换气</span>
          </div>
          <div @click="frontCurtain" class="btn flex-center"
            style="position: absolute;left: 84%;top: 17%;;border: 1px solid #fff;box-shadow: 0 0 10px #fff;background-color: #5f6975cc;">
            <span class="tit" style="color: #fff;">窗帘</span>
          </div>
          <div @click="openProjection" class="btn flex-center"
            style="position: absolute;left: 54.3%;top: 8%;border: 1px solid #fff;box-shadow: 0 0 10px #fff;background-color: #5f6975cc;">
            <span class="tit" style="color: #fff;">投影仪</span>
          </div>
          <div @click="frontSideLamp" class="btn flex-center" style="position: absolute;left: 1%;top: 2%;">
            <span class="tit">前侧灯</span>
          </div>
          <div @click="rearSideLights" class="btn flex-center" style="position: absolute;left: 5%;top: 2%;">
            <span class="tit">后侧灯</span>
          </div>

          <div @click="frontDownlight" class="btn flex-center" style="position: absolute;left: 11%;top: 2%;">
            <span class="tit">前筒灯</span>
          </div>
          <div @click="rearDownlight" class="btn flex-center" style="position: absolute;left: 15%;top: 2%;">
            <span class="tit">后筒灯</span>
          </div>
          <div @click="sideWallLamp" class="btn flex-center" style="position: absolute;left: 17%;top: 14%;">
            <span class="tit">壁灯</span>
          </div>
          <div @click="frontLightBelt" class="btn flex-center" style="position: absolute;left: 21%;top: 2%;">
            <span class="tit">前灯带</span>
          </div>
          <div @click="rearLightStrip" class="btn flex-center" style="position: absolute;left: 25%;top: 2%;">
            <span class="tit">后灯带</span>
          </div>
          <div class="echarts-line-dl">
            <div ref="echartsdl" style="width: 100%;height: 100%;"></div>
          </div>
        </div>
        <div class="main-right"></div>
      </div>
      <div class="lx-content-body-bottom flex-center">
        <div class="bottom-left">
          <div style='width: 100%;height: 100%;padding: 20px 20px;'>
            <div style="width: 100%;height: 100%;" ref="echartstemp"></div>
          </div>
        </div>
        <div class="bottom-center flex-center" style="flex-wrap: wrap;">
          <div class="btn flex-center" style="margin-right: 15px;">
            <span class="tit" @click="goWork">会议模式</span>
          </div>
          <div class="btn flex-center" style="margin-right: 15px;">
            <span class="tit" @click="projection">演讲模式</span>
          </div>
          <div class="btn flex-center" style="margin-right: 15px;">
            <span class="tit" @click="tongwin">离开模式</span>
          </div>
          <div class="btn flex-center" style="margin-right: 15px;">
            <span class="tit">合闸/分闸</span>
          </div>
          <div class="flex-center" style="width: 100%;"><span style="color: #fff;">
              温度设定
            </span></div>
          <div @click="verticalAirConditioningOnNum" class="btn flex-center" style="margin-right: 15px;">
            <span class="tit" style="font-size: 3vh;">+</span>
          </div>
          <div class="btn flex-center" style="margin-right: 15px;">
            <span class="tit">{{ num }}℃</span>
          </div>
          <div @click="num--" class="btn flex-center" style="margin-right: 15px;">
            <span class="tit" style="font-size: 3vh;">-</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 把问题看透 
import echarts from 'echarts'
import { reject, resolve } from 'q';
import service from '../../service/leftService.js'
export default {
  components: {
  },
  props: {
  },
  data() {
    return {
      timer: null,
      num: '24',
      vedioSrc: '',
      xdata: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''], // 1000
      tempData: [],
      humdData: [],
      co2Data: [],
      vocData: [],
      euData: [],
      eaData: [],
      interfaseData: {
        args: ['TH环境数据接口', 'TH电流数据接口']
      },
      airData: {
        Temp: '0.00',
        Humd: '0.00',
        CO2: '0.00',
        VOC: '0.00',
      },
      airof: {
        temp: "31",
        text: "多云",
        windDir: "西南风",
        humidity: "43"
      },
      airStatus: 0,
      echartsXsize: 0,
      dia: '0.00',
      codata: '0.00'
    }
  },
  computed: {

  },
  created() {
    /* let _this = this
    this.$nextTick(function () {
      this.$ajax.post('https://open.ys7.com/api/lapp/token/get?appKey=9b0459cbbabb44bbb6dffd9f00eaaac2&appSecret=193f43adaf7c056bc5d6c99bb769fa4f', {
        appKey: '9b0459cbbabb44bbb6dffd9f00eaaac2',
        appSecret: '193f43adaf7c056bc5d6c99bb769fa4f'
      })
        .then(function (response) {
          let accessToken = response.data.data.accessToken
          _this.vedioSrc = 'https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/G82368389/1.live&autoplay=1&accessToken=' + accessToken + '&id=ysopen'
        })
        .catch(function (error) {
          console.log(error);
        });
    }); */
  },
  methods: {
    // 获取视频token
    getTok() {
      service.tokenYingshi().then(res => {
        let token = res.accessToken
        this.vedioSrc = `https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/G82368389/1.live&autoplay=1&accessToken=${token}&id=ysopen`
      }).catch(err => {

      })
    },
    // 获取数据接口 
    getInterfaceData(obj) {
      return new Promise((resovle, reject) => {
        $.ajax({
          type: 'POST',
          url: 'http://222.128.47.96:15800/manage-object/interface/getPublicData',
          data: JSON.stringify(obj),
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': localStorage.getItem('Authorization')
          },
          success: (res) => {
            resovle(res)
          },
          erroe: (err) => {
            reject(err)
          }
        })
      })
    },
    echartsDrawLine() {
      let echartsdl = echarts.init(this.$refs.echartsdl);
      echartsdl.setOption(
        {
          title: {
            text: '电流',
            textStyle: {
              align: 'right',
              color: '#2e81ff',
              fontSize: 10,
            },
            top: '1%',
            left: 'right',
          },
          backgroundColor: '',
          grid: {
            left: '2%',
            right: '2%',
            top: '20%',
            bottom: '1%',
            containLabel: true
          },
          tooltip: {
            show: true,
            trigger: 'item'
          },
          legend: {
            show: false,
            x: 'center',
            y: '35',
            icon: 'stack',
            itemWidth: 10,
            itemHeight: 10,
            textStyle: {
              color: '#1bb4f6'
            },
            data: ['已采纳', '已发布']
          },
          xAxis: [{
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              color: "rgb(18,129,234)"
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#167ce7'
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#195384'
              }
            },
            data: this.xdata
          }],
          yAxis: [{
            type: 'value',
            name: '',
            axisLabel: {
              show: false,
              formatter: '{value}',
              textStyle: {
                color: '#1a8ced'
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#1674c2'
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#11366e'
              }
            }
          },
          ],
          series: [
            {
              name: '已采纳',
              type: 'line',
              symbol: 'none',
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: '#0092f6',
                  lineStyle: {
                    color: "#ff7504",
                    width: 1
                  },
                }
              },
              lineStyle: {
                shadowColor: "#0093b4", //透明的颜色
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                opacity: 1, //透明度
                shadowBlur: 8, //阴影大小
                type: "solid", //实线 
                width: 2,
              },
              markPoint: {
                itemStyle: {
                  normal: {
                    color: 'red'
                  }
                }
              },
              data: this.eaData
            },
          ]
        }
      )
      window.addEventListener('resize', () => {
        echartsdl.resize()
      })
      let echartstemp = echarts.init(this.$refs.echartstemp);
      echartstemp.setOption(
        {
          title: {
            text: '空气',
            textStyle: {
              align: 'right',
              color: '#2e81ff',
              fontSize: 10,
            },
            top: '1%',
            left: 'right',
          },
          backgroundColor: '',
          grid: {
            left: '2%',
            right: '2%',
            top: '21%',
            bottom: '0%',
            containLabel: true
          },
          tooltip: {
            show: true,
            trigger: 'item'
          },
          legend: {
            show: true,
            x: 'center',
            y: '-3',
            icon: 'stack',
            itemWidth: 10,
            itemHeight: 10,
            textStyle: {
              color: '#1bb4f6'
            },
            data: ['co2', 'voc', '温度', '湿度']
          },
          xAxis: [{
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              color: "rgb(18,129,234)"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#167ce7'
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#195384'
              }
            },
            data: this.xdata
          }],
          yAxis: [{
            type: 'value',
            name: '',
            axisLabel: {
              show: true,
              formatter: '{value}',
              textStyle: {
                color: '#1a8ced'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#1674c2'
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#11366e'
              }
            }
          }, {
            type: 'value',
            name: '',
            axisLabel: {
              show: true,
              formatter: '{value}',
              textStyle: {
                color: '#1a8ced'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#1674c2'
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#11366e'
              }
            }
          },
          ],
          series: [
            {
              name: 'co2',
              type: 'line',
              symbol: 'none',
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: '#0092f6',
                  lineStyle: {
                    color: "#0092f6",
                    width: 1
                  },
                }
              },
              lineStyle: {
                shadowColor: "#0093b4", //透明的颜色
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                opacity: 1, //透明度
                shadowBlur: 8, //阴影大小
                type: "solid", //实线
                width: 2,
              },
              markPoint: {
                itemStyle: {
                  normal: {
                    color: 'red'
                  }
                }
              },
              data: this.co2Data
            },
            {
              name: 'voc',
              type: 'line',
              symbol: 'none',
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: '#34dcfc',
                  lineStyle: {
                    color: "#34dcfc",
                    width: 1
                  },
                }
              },
              lineStyle: {
                shadowColor: "#0093b4", //透明的颜色
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                opacity: 1, //透明度
                shadowBlur: 8, //阴影大小
                type: "solid", //实线
                width: 2,
              },
              markPoint: {
                itemStyle: {
                  normal: {
                    color: 'red'
                  }
                }
              },
              data: this.vocData
            },
            {
              name: '温度',
              yAxisIndex: 1,
              type: 'line',
              symbol: 'none',
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: '#ffaa00cc',
                  lineStyle: {
                    color: "#ffaa00cc",
                    width: 1
                  },
                }
              },
              lineStyle: {
                shadowColor: "#0093b4", //透明的颜色
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                opacity: 1, //透明度
                shadowBlur: 8, //阴影大小
                type: "solid", //实线
                width: 2,
              },
              markPoint: {
                itemStyle: {
                  normal: {
                    color: 'red'
                  }
                }
              },
              data: this.tempData
            },
            {
              name: '湿度',
              yAxisIndex: 1,
              type: 'line',
              symbol: 'none',
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: '#00ff11cc',
                  lineStyle: {
                    color: "#00ff11cc",
                    width: 1
                  },
                }
              },
              lineStyle: {
                shadowColor: "#0093b4", //透明的颜色
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                opacity: 1, //透明度
                shadowBlur: 8, //阴影大小
                type: "solid", //实线
                width: 2,
              },
              markPoint: {
                itemStyle: {
                  normal: {
                    color: 'red'
                  }
                }
              },
              data: this.humdData
            },
          ]
        }
      )
      window.addEventListener('resize', () => {
        echartstemp.resize()
      })
    },
    // 获取数据接口  
    getDataInter() {
      return new Promise((resolve, reject) => {
        service.getPublicData(this.interfaseData).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // echarts曲线的q
    async echartsLineData() {
      let myDate = new Date();
      let yell = myDate.getYear();
      let mounth = myDate.getMonth() + 1
      mounth < 10 ? mounth = `0${mounth}` : mounth
      let day = myDate.getDate()
      day < 10 ? day = `0${day}` : day
      let week = myDate.getDay()
      let house = myDate.getHours();
      house < 10 ? house = `0${house}` : house
      let minutes = myDate.getMinutes();
      minutes < 10 ? minutes = `0${minutes}` : minutes
      let second = myDate.getSeconds();
      second < 10 ? second = `0${second}` : second
      let time = house + ":" + minutes
      let showTime = house + ":" + minutes + ":" + second
      let yellTime = '2022' + '/' + mounth + '/' + day
      let obj = {
        args: ['TH环境数据接口', 'TH电流数据接口']
      }
      let data = await this.getInterfaceData(obj)
      let arr = data.data
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].deviceName == 'Tellhow-01') {
          if (arr[i].name == 'T_Temp') {
            this.airData.Temp = arr[i].value
            if (this.echartsXsize > 2000) {
              this.echartsXsize = 2200
              this.tempData.shift()
              this.tempData.push(arr[i].value)
            } else {
              this.tempData.push(arr[i].value)
            }
          }
          if (arr[i].name == 'H_Humd') {
            this.airData.Humd = arr[i].value
            if (this.echartsXsize > 2000) {
              this.humdData.shift()
              this.humdData.push(arr[i].value)
            } else {
              this.humdData.push(arr[i].value)
            }
          }
          if (arr[i].name == 'CO2_CO2') {
            this.airData.CO2 = arr[i].value
            if (this.echartsXsize > 2000) {
              this.co2Data.shift()
              this.co2Data.push(arr[i].value)
            } else {
              this.co2Data.push(arr[i].value)
            }
          }
          if (arr[i].name == 'VOC_VOC') {
            this.airData.VOC = arr[i].value
            if (this.echartsXsize > 2000) {
              this.vocData.shift()
              this.vocData.push(arr[i].value)
            } else {
              this.vocData.push(arr[i].value)
            }
          }
          if (arr[i].name == 'EI_Current') {


          }
          if (arr[i].name == 'EPP_Hwh') {
            this.dia = arr[i].value
            this.codata = arr[i].value * 0.997
          }
          if (arr[i].name == 'EP_Kw') {
            if (this.echartsXsize > 2000) {
              this.eaData.shift()
              this.eaData.push(arr[i].value)
            } else {
              this.eaData.push(arr[i].value)
            }
          }
          if (arr[i].name == 'EI_Current') {

          }
        }
      }
      if (this.echartsXsize > 2000) {
        this.echartsXsize = 2100
        this.xdata.shift()
        this.xdata.push(time)
      } else {
        this.xdata.splice(this.echartsXsize, 1, time)
      }
      this.echartsXsize++
      this.echartsDrawLine()
    },
    // 修改数据接口 
    setUpdataData(val) {
      return new Promise((resovle, reject) => {
        $.ajax({
          type: 'POST',
          url: 'http://222.128.47.96:15800/manage-object/deviceControl/updatePhysicalPoint',
          data: JSON.stringify(val),
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': localStorage.getItem('Authorization')
          },
          success: (res) => {
            resovle(res)
          },
          erroe: (err) => {
            reject(err)
          }
        })
      })
    },
    // 获取数据接口
    getData(dataId) {
      return new Promise((resovle, reject) => {
        $.ajax({
          type: 'GET',
          url: 'http://222.128.47.96:15800/manage-object/project/getChildren',
          data: {
            id: dataId,
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': localStorage.getItem('Authorization')
          },
          success: (res) => {
            resovle(res)
          },
          erroe: (err) => {
            reject(err)
          }
        })
      })
    },
    // 前排灯带
    async frontLightBelt() {
      let cwAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】前排灯带",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light2",
        id: "62bd15f988fcda5b459cc453",
        name: "RS_Light2",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: 0
      }
      let data = await this.getData('62bd15f988fcda5b459cc451')
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].name == 'RS_Light2') {
          if (data.data[i].value == '0.00' || data.data[i].value == '0') {
            cwAirData.value = 1
            $('.q1').css('background-image', 'url(images/th/ligbtn2.png)')
          } else {
            cwAirData.value = 0
            $('.q1').css('background-image', 'url(images/th/ligbtn.png)')
          }
        }
      };
      await this.setUpdataData(cwAirData)
    },
    // 前排筒灯
    async frontDownlight() {
      let cwAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】前排筒灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light1",
        id: "62bd15f988fcda5b459cc452",
        name: "RS_Light1",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      let data = await this.getData('62bd15f988fcda5b459cc451')
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].name == 'RS_Light1') {
          if (data.data[i].value == '0.00' || data.data[i].value == '0') {
            cwAirData.value = 1
          } else {
            cwAirData.value = 0
          }
        }
      };
      await this.setUpdataData(cwAirData)
    },
    // 前排测灯
    async frontSideLamp() {
      let cwAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】前排测灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light3",
        id: "62bd15f988fcda5b459cc454",
        name: "RS_Light3",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      let data = await this.getData('62bd15f988fcda5b459cc451')
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].name == 'RS_Light3') {
          if (data.data[i].value == '0.00' || data.data[i].value == '0') {
            cwAirData.value = 1
          } else {
            cwAirData.value = 0
          }
        }
      };
      await this.setUpdataData(cwAirData)
    },
    // 后排灯带
    async rearLightStrip() {
      let cwAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】后排灯带",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light5",
        id: "62bd15f988fcda5b459cc456",
        name: "RS_Light5",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      let data = await this.getData('62bd15f988fcda5b459cc451')
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].name == 'RS_Light5') {
          if (data.data[i].value == '0.00' || data.data[i].value == '0') {
            cwAirData.value = 1
          } else {
            cwAirData.value = 0
          }
        }
      };
      await this.setUpdataData(cwAirData)
    },
    // 后排筒灯
    async rearDownlight() {
      let cwAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】后排筒灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light4",
        id: "62bd15f988fcda5b459cc455",
        name: "RS_Light4",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      let data = await this.getData('62bd15f988fcda5b459cc451')
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].name == 'RS_Light4') {
          if (data.data[i].value == '0.00' || data.data[i].value == '0') {
            cwAirData.value = 1
          } else {
            cwAirData.value = 0
          }
        }
      };
      await this.setUpdataData(cwAirData)
    },
    // 后排侧灯
    async rearSideLights() {
      let cwAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】后排测灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light6",
        id: "62bd15f988fcda5b459cc457",
        name: "RS_Light6",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      let data = await this.getData('62bd15f988fcda5b459cc451')
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].name == 'RS_Light6') {
          if (data.data[i].value == '0.00' || data.data[i].value == '0') {
            cwAirData.value = 1
          } else {
            cwAirData.value = 0
          }
        }
      };
      await this.setUpdataData(cwAirData)
    },
    // 侧边壁灯
    async sideWallLamp() {
      let cwAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】壁灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light7",
        id: "62bd15f988fcda5b459cc458",
        name: "RS_Light7",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      let data = await this.getData('62bd15f988fcda5b459cc451')
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].name == 'RS_Light7') {
          if (data.data[i].value == '0.00' || data.data[i].value == '0') {
            cwAirData.value = 1
            $('.cb1').css('background-image', 'url(images/th/ligbtn2.png)')
          } else {
            cwAirData.value = 0
            $('.cb1').css('background-image', 'url(images/th/ligbtn.png)')
          }
        }
      };
      await this.setUpdataData(cwAirData)
    },
    // 前排窗帘
    async frontCurtain() {
      let cwAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-02-ICUCMD-RS_window01",
        id: "62c00f3588fcda5b459cc504",
        name: "RS_window01",
        parentId: "62c00f3588fcda5b459cc502",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      let data = await this.getData('62c00f3588fcda5b459cc502')
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].name == 'RS_window01') {
          if (data.data[i].value == '0.00' || data.data[i].value == '0') {
            cwAirData.value = 1
          } else {
            cwAirData.value = 0
          }
        }
      };
      await this.setUpdataData(cwAirData)
    },
    // 立式空调开
    async verticalAirConditioningOn() {
      if (airStatus == 0) {
        let cwAirData = {
          attribute: {
            alarmState: "正常",
            pointType: true
          },
          description: null,
          fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-RS-KTC-N01-INT_KT_24",
          id: "62be9a1e88fcda5b459cc497",
          name: "INT_KT_24",
          parentId: "62bd523588fcda5b459cc466",
          secondName: null,
          type: "value_Analog",
          unit: null,
          value: "1"
        }
        await this.setUpdataData(cwAirData)
        this.airStatus = 1
      } else {
        this.airStatus = 0
        this.verticalAirConditioningOff()
      }
    },
    async verticalAirConditioningOnNum() {
      this.num++
      let cwAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-RS-KTC-N01-INT_KT_24",
        id: "62be9a1e88fcda5b459cc497",
        name: "INT_KT_24",
        parentId: "62bd523588fcda5b459cc466",
        secondName: null,
        type: "value_Analog",
        unit: null,
        value: "1"
      }
      await this.setUpdataData(cwAirData)
    },
    // 立式空调关
    async verticalAirConditioningOff() {
      let data = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-RS-KTC-N01-INT_KT_Off",
        id: "62be9a1e88fcda5b459cc493",
        name: "INT_KT_Off",
        parentId: "62bd523588fcda5b459cc466",
        secondName: null,
        type: "value_Analog",
        unit: null,
        value: "1"
      }
      this.setUpdataData(data)
    },
    // 新风机开
    async freshAirFanOn() {
      let cwAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-02-ICUCMD-RS_xinfeng",
        id: "62c00f3588fcda5b459cc503",
        name: "RS_xinfeng",
        parentId: "62c00f3588fcda5b459cc502",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1"
      }
      let data = await this.getData('62c00f3588fcda5b459cc502')
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].name == 'RS_xinfeng') {
          if (data.data[i].value == '0.00' || data.data[i].value == '0') {
            cwAirData.value = 1
          } else {
            cwAirData.value = 0

          }
        }
      };
      this.setUpdataData(cwAirData)
    },
    // 会议模式
    async goWork() {
      // 立式空调开
      let cwAirData1 = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-RS-KTC-N01-INT_KT_24",
        id: "62be9a1e88fcda5b459cc497",
        name: "INT_KT_24",
        parentId: "62bd523588fcda5b459cc466",
        secondName: null,
        type: "value_Analog",
        unit: null,
        value: "1"
      }
      this.setUpdataData(cwAirData1)

      // 前排筒灯
      let meetingMinData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】前排筒灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light1",
        id: "62bd15f988fcda5b459cc452",
        name: "RS_Light1",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1"
      }
      await this.setUpdataData(meetingMinData)

      // 前排灯带
      let cwAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】前排灯带",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light2",
        id: "62bd15f988fcda5b459cc453",
        name: "RS_Light2",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1.00"
      }
      await this.setUpdataData(cwAirData)

      // 前排测灯
      let meetingMaxata = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】前排测灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light3",
        id: "62bd15f988fcda5b459cc454",
        name: "RS_Light3",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1.00"
      }
      await this.setUpdataData(meetingMaxata)

      // 后排筒灯
      let swAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】后排筒灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light4",
        id: "62bd15f988fcda5b459cc455",
        name: "RS_Light4",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1.00"
      }
      await this.setUpdataData(swAirData)

      // 后排灯带
      let yjAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】后排灯带",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light5",
        id: "62bd15f988fcda5b459cc456",
        name: "RS_Light5",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1.00"
      }
      await this.setUpdataData(yjAirData)

      // 后排测灯
      let hkAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】后排测灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light6",
        id: "62bd15f988fcda5b459cc457",
        name: "RS_Light6",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1.00"
      }
      await this.setUpdataData(hkAirData)

      // 壁灯
      let csjAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】壁灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light7",
        id: "62bd15f988fcda5b459cc458",
        name: "RS_Light7",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1.00"
      }
      await this.setUpdataData(csjAirData)

      // 空调
      let laight1 = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-FANCMD-RS_FAN",
        id: "62bebd7888fcda5b459cc4a1",
        name: "RS_FAN",
        parentId: "62bebd7888fcda5b459cc49b",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1.00",
      }
      await this.setUpdataData(laight1)

      // 前窗帘
      let win1 = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-02-ICUCMD-RS_window01",
        id: "62c00f3588fcda5b459cc504",
        name: "RS_window01",
        parentId: "62c00f3588fcda5b459cc502",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1"
      }
      await this.setUpdataData(win1)

      // 后窗帘
      let win2 = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-02-ICUCMD-RS_window02",
        id: "62c00f3588fcda5b459cc505",
        name: "RS_window02",
        parentId: "62c00f3588fcda5b459cc502",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1"
      }
      await this.setUpdataData(win2)

      let xinFen = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-02-ICUCMD-RS_xinfeng",
        id: "62c00f3588fcda5b459cc503",
        name: "RS_xinfeng",
        parentId: "62c00f3588fcda5b459cc502",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1"
      }
      await this.setUpdataData(xinFen)
    },
    // 演讲模式
    async projection() {
      // 前排筒灯
      let meetingMinData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】前排筒灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light1",
        id: "62bd15f988fcda5b459cc452",
        name: "RS_Light1",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      await this.setUpdataData(meetingMinData)

      // 前排灯带
      let cwAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】前排灯带",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light2",
        id: "62bd15f988fcda5b459cc453",
        name: "RS_Light2",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      await this.setUpdataData(cwAirData)

      // 前排测灯
      let meetingMaxata = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】前排测灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light3",
        id: "62bd15f988fcda5b459cc454",
        name: "RS_Light3",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      await this.setUpdataData(meetingMaxata)

      // 后排筒灯
      let swAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】后排筒灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light4",
        id: "62bd15f988fcda5b459cc455",
        name: "RS_Light4",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1.00"
      }
      await this.setUpdataData(swAirData)

      // 后排灯带
      let yjAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】后排灯带",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light5",
        id: "62bd15f988fcda5b459cc456",
        name: "RS_Light5",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1.00"
      }
      await this.setUpdataData(yjAirData)

      // 后排测灯
      let hkAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】后排测灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light6",
        id: "62bd15f988fcda5b459cc457",
        name: "RS_Light6",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1.00"
      }
      await this.setUpdataData(hkAirData)

      // 壁灯
      let csjAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】壁灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light7",
        id: "62bd15f988fcda5b459cc458",
        name: "RS_Light7",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1.00"
      }
      await this.setUpdataData(csjAirData)

      // 空调
      let laight1 = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-FANCMD-RS_FAN",
        id: "62bebd7888fcda5b459cc4a1",
        name: "RS_FAN",
        parentId: "62bebd7888fcda5b459cc49b",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1.00",
      }
      await this.setUpdataData(laight1)

      // 前窗帘
      let win1 = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-02-ICUCMD-RS_window01",
        id: "62c00f3588fcda5b459cc504",
        name: "RS_window01",
        parentId: "62c00f3588fcda5b459cc502",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1"
      }
      await this.setUpdataData(win1)

      // 后窗帘
      let win2 = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-02-ICUCMD-RS_window02",
        id: "62c00f3588fcda5b459cc505",
        name: "RS_window02",
        parentId: "62c00f3588fcda5b459cc502",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1"
      }
      await this.setUpdataData(win2)

      let xinFen = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-02-ICUCMD-RS_xinfeng",
        id: "62c00f3588fcda5b459cc503",
        name: "RS_xinfeng",
        parentId: "62c00f3588fcda5b459cc502",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "1"
      }
      await this.setUpdataData(xinFen)


      let cwAirDataLishi = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-RS-KTC-N01-INT_KT_24",
        id: "62be9a1e88fcda5b459cc497",
        name: "INT_KT_24",
        parentId: "62bd523588fcda5b459cc466",
        secondName: null,
        type: "value_Analog",
        unit: null,
        value: "1"
      }
      await this.setUpdataData(cwAirDataLishi)
    },
    // 离开模式
    async tongwin() {
      // 前排筒灯
      let meetingMinData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】前排筒灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light1",
        id: "62bd15f988fcda5b459cc452",
        name: "RS_Light1",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      await this.setUpdataData(meetingMinData)

      // 前排灯带
      let cwAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】前排灯带",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light2",
        id: "62bd15f988fcda5b459cc453",
        name: "RS_Light2",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      await this.setUpdataData(cwAirData)

      // 前排测灯
      let meetingMaxata = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】前排测灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light3",
        id: "62bd15f988fcda5b459cc454",
        name: "RS_Light3",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      await this.setUpdataData(meetingMaxata)

      // 后排筒灯
      let swAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】后排筒灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light4",
        id: "62bd15f988fcda5b459cc455",
        name: "RS_Light4",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      await this.setUpdataData(swAirData)

      // 后排灯带
      let yjAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】后排灯带",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light5",
        id: "62bd15f988fcda5b459cc456",
        name: "RS_Light5",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      await this.setUpdataData(yjAirData)

      // 后排测灯
      let hkAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】后排测灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light6",
        id: "62bd15f988fcda5b459cc457",
        name: "RS_Light6",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      await this.setUpdataData(hkAirData)

      // 壁灯
      let csjAirData = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: "【读写】壁灯",
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-ICUCMD-RS_Light7",
        id: "62bd15f988fcda5b459cc458",
        name: "RS_Light7",
        parentId: "62bd15f988fcda5b459cc451",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      await this.setUpdataData(csjAirData)

      // 空调
      let laight1 = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-FANCMD-RS_FAN",
        id: "62bebd7888fcda5b459cc4a1",
        name: "RS_FAN",
        parentId: "62bebd7888fcda5b459cc49b",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0",
      }
      await this.setUpdataData(laight1)

      // 前窗帘
      let win1 = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-02-ICUCMD-RS_window01",
        id: "62c00f3588fcda5b459cc504",
        name: "RS_window01",
        parentId: "62c00f3588fcda5b459cc502",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      await this.setUpdataData(win1)

      // 后窗帘
      let win2 = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-02-ICUCMD-RS_window02",
        id: "62c00f3588fcda5b459cc505",
        name: "RS_window02",
        parentId: "62c00f3588fcda5b459cc502",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      await this.setUpdataData(win2)

      // 立式空调
      let data = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-RS-KTC-N01-INT_KT_Off",
        id: "62be9a1e88fcda5b459cc493",
        name: "INT_KT_Off",
        parentId: "62bd523588fcda5b459cc466",
        secondName: null,
        type: "value_Analog",
        unit: null,
        value: "1"
      }
      await this.setUpdataData(data)

      // 新风关
      let xinFen = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-02-ICUCMD-RS_xinfeng",
        id: "62c00f3588fcda5b459cc503",
        name: "RS_xinfeng",
        parentId: "62c00f3588fcda5b459cc502",
        secondName: null,
        type: "BinaryOutput",
        unit: null,
        value: "0"
      }
      await this.setUpdataData(xinFen)
    },
    // 投影开关
    openProjection() {
      let projection = {
        attribute: {
          alarmState: "正常",
          pointType: true
        },
        description: null,
        fullName: "微瓴平台-饱和数据测试-北京办公室服务器-项目调试-泰豪会议室-Tellhow-01-RS-KTC-N01-INT_TY_SW",
        id: "62be9aed88fcda5b459cc49a",
        name: "INT_TY_SW",
        parentId: "62bd523588fcda5b459cc466",
        secondName: null,
        type: "value_Analog",
        unit: null,
        value: "1"
      }
      this.setUpdataData(projection)
      setTimeout(() => {
        this.setUpdataData(projection)
      }, 2000)

      setTimeout(() => {
        this.setUpdataData(projection)
      }, 3000)
    },
    // 和风天气 
    hefeng() {
      return new Promise((resovle, reject) => {
        $.ajax({
          type: 'GET',
          url: 'https://devapi.qweather.com/v7/weather/now?location=101010100&key=cb8885d03abc4412ab83212e87a4fddf',
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          success: (data) => {
            this.airof.temp = data.now.temp
            this.airof.text = data.now.text
            this.airof.windDir = data.now.windDir
            this.airof.humidity = data.now.humidity
          },
          erroe: (err) => {
            console.log(err)
          }
        })
      })
    }
  },
  mounted() {
    this.getTok()
    this.hefeng()
    this.$nextTick(function () {
      this.echartsDrawLine();
    });
    this.timer = setInterval(() => {
      this.echartsLineData()
    }, 1000)
  },
  destroyed() {
    clearInterval(this.timer);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
}
</script>

<style scoped type="text/css">
.flex {
  display: flex;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-jus-center {
  display: flex;
  justify-content: center;
}

.flex-al-center {
  display: flex;
  align-items: center;
}

.lx-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.lx-content-body {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
  overflow: hidden;
}

.lx-content-body-top {
  width: 100%;
  height: 8%;
  background-image: url("../../../static/img/fisheries/lx_bg_top.png");
}

.lx-content-body-top_bg {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-image: url("../../../static/img/fisheries/mian-title.png");
}

.lx-content-body-bottom {
  width: 100%;
  height: 20%;
  position: fixed;
  bottom: 0;
  background-size: 100% 100%;
  background-image: url("../../../static/img/fisheries/lx_bg_bottom.png");
  box-sizing: border-box;
  padding: 10px 10px;
}

.lx-content-body-content {
  width: 100%;
  height: 72%;
}

.main-left {
  width: 1%;
  height: 100%;
  background-color: #000c2e;
}

.main-center {
  width: 98%;
  height: 100%;
  position: relative;
  border: 0px solid #045cff;
  box-shadow: #045cff 0px 0px 50px inset;
  background-size: 100% 100%;
}

.main-right {
  width: 1%;
  height: 100%;
  background-color: #000c2e;
}

.body-top-left {
  width: 25%;
  height: 70%;
}

.body-top-center {
  width: 50%;
  height: 90%;
}

.main-tit {
  font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
  background-image: -webkit-linear-gradient(bottom, #024ec0, #84ebfd);
  font-size: 3vh;
  font-weight: 800;
  letter-spacing: 10px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.body-top-right {
  width: 27%;
  height: 70%;
}

.icon-xuan {
  width: 3rem;
  height: 3rem;
  /*  background-image: url("../../../static/img/lengdongzhan/xuanzhuan.gif"); */
  background-size: 100% 100%;
}

.content-span {
  background-image: -webkit-linear-gradient(bottom, #024ec0, #84ebfd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 1.7vh;
}

.air {
  width: 2rem;
  height: 2.5rem;
  position: absolute;
  background-image: url("../../../static/img/lengdongzhan/1.gif");
  background-size: 100% 100%;
}

.btn {
  width: 2rem;
  height: 1rem;
  border: 1px solid rgb(213, 237, 252);
  border-radius: 5px;
  cursor: pointer;
  --c: rgba(222, 235, 255, 0.75);
  box-shadow: 0 0 10px var(--c), 0 0 20px var(--c);
  background-color: #045cff1d;
}

.tit {
  color: #fff;
  font-size: 1vh;
  font-weight: 500;
  text-transform: uppercase;
  outline: none;
  --c: rgba(65, 132, 234, 0.75);
  text-shadow: 0 0 10px var(--c), 0 0 20px var(--c), 0 0 40px var(--c),
    0 0 80px var(--c), 0 0 160px var(--c);
}

@keyframes anner {
  to {
    filter: hue-rotate(40deg);
  }
}

.echarts-line-dl {
  width: 100%;
  height: 2rem;
  position: absolute;
  bottom: 0;
}

.bottom-left {
  width: 80%;
  height: 100%;
  box-sizing: border-box;
  background-image: url("../../../static/img/fisheries/plan-left-top.png");
  background-size: 100% 100%;
  margin-right: 15px;
}

.bottom-center {
  width: 20%;
  height: 100%;
  background-image: url("../../../static/img/fisheries/plan-left-top.png");
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 25px 5px;
  margin-right: 15px;
}

.air-data-box {
  width: 7%;
  height: 20%;
  position: absolute;
  border: 1px solid rgb(120, 203, 255);
  --c: rgba(94, 156, 248, 0.75);
  box-shadow: 0 0 10px var(--c), 0 0 20px var(--c);
  background-color: #045cff62;
  box-shadow: 0 0 10px var(--c), 0 0 20px var(--c);
  right: 22.5%;
  top: 17%;
}
</style>



// WEBPACK FOOTER //
// src/components/graphically/longxin.vue